<template>
  <div id="indexBox" class="indexBox" v-title="title">
    <div class="wihte-bg" v-show="isOk"></div>
    <div class="recommend" v-if="productNo && recommend && productInfo.productDetail">
      <div class="tj-product" @click="goPage(recommend.url)">
        <div class="warp">
          <div class="img-box" v-if="productInfo.productDetail.largeImg">
            <img :src="productInfo.productDetail.largeImg" alt="">
          </div>
          <div class="cost">
            <p class="money">
              <span>{{ recommend.price }}</span>
              <i class="qi">元起</i>
            </p>
            <div class="btn" @click.stop="goPage(recommend.url)">产品详情</div>
          </div>
        </div>
      </div>
    </div>
    <div :class="productNo && recommend ? 'munbox' : 'munbox un-top'" style="background: #fff">
      <van-tabs
        v-model="activeIndex"
        ref="vanTabRef"
        :color="theme.productBtnColor"
        v-if="navBtnStyle == 1 && activeIndex && productTypeChildList.length"
        :class="{ bb: navBtnStyle == 1 }"
        @change="changeType"
        :title-active-color="theme.productBtnColor"
      >
        <van-tab :title="item.name" v-for="(item, index) in productTypeList" :key="item.id" :name="index + ''"></van-tab>
      </van-tabs>
      <div class="munContent clearfix" v-else>
        <div
          v-for="(item, index) in productTypeList"
          :key="index"
          :class="['mun2Item', item.id == seleteProductType.id ? 'active' : '']"
          :style="theme && item.id == seleteProductType.id ? { color: theme.productBtnColor, background: productBtnBackground } : ''"
          @click="productTypeClick(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="munContent clearfix child-type-list" v-if="navBtnStyle == 1 && productTypeChildList.length > 1">
        <div
          v-for="(item, index) in productTypeChildList"
          :key="index"
          :class="['mun2Item', item.id == seleteProductTypeChild.id ? 'active' : '']"
          :style="theme && item.id == seleteProductTypeChild.id ? { color: theme.productBtnColor, background: productBtnBackground } : ''"
          @click="productTypeClick(item, 'child')"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <!-- 产品列表 start -->
    <div class="list-content">
      <div class="product-list">
        <div v-for="(item, i) in data" class="product-item clearfix" @click="goPage(item.url)" :key="i">
          <div class="tagbox" v-if="item.tag" :style="theme ? { background: theme.productTagColor } : ''">{{ item.tag }}</div>
          <div class="item-img-left fl" :style="{ backgroundImage: 'url(' + item.shortImg + ')' }"></div>
          <div class="item-warp-rigth">
            <p class="product-title">{{ item.productName }}</p>
            <div class="product-desc" style="-webkit-box-orient: vertical">{{ item.profile }}</div>
            <div class="product-cost clearfix">
              <p class="money fl">
                <span>{{ item.price * 1 }}</span>
                <i class="qi">元起</i>
              </p>
              <div class="btn fr">
                <span
                  v-if="item.buttonOne"
                  :style="theme ? { color: theme.productBtnColor, borderColor: theme.productBtnColor } : ''"
                  @click.stop="goPage(item.buttonOneUrl)"
                  >{{ item.buttonOne }}</span
                >
                <span
                  v-if="item.buttonTwo"
                  :style="theme ? { color: theme.productBtnColor, borderColor: theme.productBtnColor } : ''"
                  @click.stop="goPage(item.buttonTwoUrl)"
                  >{{ item.buttonTwo }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hgbx">产品和服务由{{ complayArr }}提供</div>
    <!-- 产品列表 end -->
  </div>
</template>
<script>
// import orderSearch from './orderSearch'
import navTap from '../components/navTap'
import common from '../api/common'
import mothed from '../api/motheds'
import MescrollVue from 'mescroll.js/mescroll.vue'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
var vm = null
export default {
  name: 'indexBox',
  data() {
    return {
      activeIndex: '0',
      recommend: {}, // 推荐产品
      productInfo: {}, // 推荐产品详情 产品中心数据
      productNo: '', // 产品code，网销产品从机构后台商品库跳转过来，显示为推荐产品
      websiteCode: '',
      websiteId: '',
      productBtnBackground: '', // 按钮背景色
      xcx: false,
      title: '',
      complayArr: '',
      navTapData: [
        {
          icon: require('static/images/all.png'),
          title: '所有产品',
          path: '/allProduct',
        },
        {
          icon: require('static/images/search.png'),
          title: '查询保单',
          path: '/queryPolicy',
        },
        {
          icon: require('static/images/dingdong.png'),
          title: '无忧理赔',
          path: '/claimPic',
        },
      ],
      data: [],
      basUrl: common.api_root,
      channelId: '',
      procode: mothed.codeLink(),
      mescroll: null, //mescroll实例对象
      productTypeList: [],
      seleteProductType: {},
      productTypeChildList: [],
      seleteProductTypeChild: {},
      mechanId: '',
      theme: {},
      themeId: '',
      navBtnStyle: '',
      loading: '',
      isOk: false,
    }
  },
  created() {
    vm = this
    if (this.$route.query.xcx == 1) {
      this.xcx = true
    }
    this.websiteCode = this.$tool.tools().getQueryString('websiteCode')
    this.productNo = this.$tool.tools().getQueryString('productNo')
    this.loading = this.$popup.loading()
    if(this.productNo) {
      this.getProductInfo()
    }
  },
  methods: {
    changeType(index) {
      if (this.productTypeList.length == 0) {
        return
      }
      let item = this.productTypeList[index]
      this.productTypeClick(item)
    },
    goPage(url) {
      if (!url) {
        return
      }
      if (window.__wxjs_environment === 'miniprogram') {
        sessionStorage.xcxJumpData = JSON.stringify({
          action: 'goPage',
          url: url,
        })
        location.href = '/apps/uni.html'
      } else {
        const param = this.getParams(this.$route.query)
        if (param) {
          if (url.includes('?')) {
            url += "&" + param
          } else {
            url += "?" + param
          }
        }
        console.log(url)
        location.href = url
      }
    },
    getParams(params) {
      let paramStr = '';
      Object.keys(params).forEach((item) => {
        if (paramStr === '') {
          paramStr = `${item}=${params[item]}`;
        } else {
          paramStr = `${paramStr}&${item}=${params[item]}`;
        }
      });
      return paramStr;
    },
    //首页列表请求
    indexList() {
      this.$stort(1, {
        type: this.xcx ? 3 : 2,
        websiteCode: this.websiteCode,
      }).then((res) => {
        console.log(res)
        //this.data = res.products;
        //this.channelId = res.channelId;
        this.title = res.websiteName = '保险商城';
        this.websiteId = res.id
        this.mechanId = res.mechanId
        this.themeId = res.themeId
        this.theme = res.theme
        this.productBtnBackground = this.colorRgb(this.theme.productBtnColor)
        this.navBtnStyle = res.navBtnStyle
        var websiteName = res.websiteName ? res.websiteName : '精选产品'
        var wechatShareIcon =
          res.wechatShareIcon ||
          location.origin + require('static/images/indexShare.png')
        var wechatShareDescribe =
          res.wechatShareDescribe ||
          '为您精选好产品，全方位为您的家庭保障护航，快来我的保险商城具体看看吧~'
        this.productType()
        this.$wxtools().shareWx(
          websiteName,
          wechatShareIcon,
          wechatShareDescribe
        )
      })
    },
    colorRgb(sColor) {
      sColor = sColor.toLowerCase()
      // 十六进制颜色值的正则表达式
      let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
      // 如果是16进制颜色
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          let sColorNew = '#'
          for (let i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
          }
          sColor = sColorNew
        }
        // 处理六位的颜色值
        let sColorChange = []
        for (let i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
        }
        sColorChange.push(0.1)
        return 'RGB(' + sColorChange.join(',') + ')'
      }
      return sColor
    },
    productList(type) {
      this.loading = this.$popup.loading()
      var that = this
      let id = that.seleteProductType.id
      if (type == 'child' && that.seleteProductTypeChild.id != -1) {
        id = that.seleteProductTypeChild.id
      }
      this.$http.getHttp(
        {
          name: 'typeProduct',
          params: {
            isSupportWebapp: this.xcx ? 1 : 0,
            pageSize: 9999,
            pageNum: 1,
            isShow: '1',
            customProductTypeId: id == '99' ? '' : id,
            websiteId: that.websiteId,
            status: 1,
            mechanId: that.mechanId,
            productCode: that.productNo,
          },
        },
        (data) => {
          var complayNames = data.complayNames
          if (data.complayNames) {
            complayNames = complayNames.replace(/,/g, '、')
            that.complayArr = complayNames
          }
          this.data = data.data.products
          this.recommend = data.data.recommend ? data.data.recommend : {}
          layer.close(vm.loading)
          this.isOk = true
        }
      )
    },
    // 推荐产品详情
    getProductInfo() {
      this.$http.getHttp({
        url: '/insure/productDetail',
        type: 'get',
        params: {
          productCode: this.productNo,
        }
      }, (data) => {
        this.productInfo = data.data
      })
    },
    productNullList: function () {
      this.$http.getHttp(
        {
          name: 'products',
          params: {
            isSupportWebapp: this.xcx ? 1 : 0,
            pageSize: 9999,
            pageNum: 1,
            isShow: '1',
            status: '2',
            productCode: this.productNo,
            websiteId: this.websiteId
          },
        },
        (data) => {
          this.data = data.data
          this.recommend = data.recommend ? data.recommend : {}
          var complayNames = data.complayNames
          if (data.complayNames) {
            complayNames = complayNames.replace(/,/g, '、')
            this.complayArr = complayNames
          }
          layer.close(vm.loading)
          this.isOk = true
        }
      )
    },
    productType: function () {
      var that = this
      this.$http.getHttp(
        {
          name: 'productTypeNew',
          params: {
            isSupportWebapp: this.xcx,
            websiteId: that.websiteId,
          },
        },
        (data) => {
          if (data.data.length && data.data[0].name == '全部') {
            console.log('---------------', data)
            data.data[0].id = '99';
          }
          that.productTypeList = data.data;
          if (data.data && data.data.length > 0) {
            that.seleteProductType = data.data[0]
            that.productList()
            if (this.navBtnStyle == 1) {
              this.getChildProductType(that.seleteProductType.id)
            }
          } else {
            that.productNullList()
          }
        }
      )
    },
    getChildProductType(id) {
      this.productTypeChildList = []
      const allItem = { id: '-1', name: '全部' }
      this.productTypeList.forEach((item) => {
        if (item.id == id) {
          this.productTypeChildList = [allItem].concat(item.subTypes || [])
          this.seleteProductTypeChild = allItem
        }
      })
      console.log(this.productTypeChildList)
    },
    productTypeClick: function (item, type) {
      if (type == 'child') {
        this.seleteProductTypeChild = item
      } else {
        if (this.seleteProductType.id != item.id) {
          this.seleteProductType = item
          this.productTypeChildList = []
          this.seleteProductTypeChild = {}
          this.getChildProductType(item.id)
        }
      }
      this.productList(type)
    },
  },
  components: {
    // orderSearch: orderSearch,
    'nav-tap': navTap,
    'mescroll-vue': MescrollVue,
  },
  mounted() {
    this.indexList()
  },
}
</script>

<style lang="scss">
@import '../sass/pages/index';
</style>



// WEBPACK FOOTER //
// src/pages/index.vue